"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _copyPublic = require("@/libs/copyPublic");
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'i-copyright',
  data: function data() {
    return {
      copyright: 'Copyright © 2025 安徽智联数商智能科技有限公司',
      copyrightNew: 'Copyright © 2025 安徽智联数商智能科技有限公司'
    };
  },
  mounted: function mounted() {
    this.getVersion();
  },
  methods: {
    getVersion: function getVersion() {
      //   getCopyrightInfo().then((res) => {
      //     const data = res || {};
      //     this.copyrightNew = data.companyName ? data.companyName : this.copyright;
      //   });
    }
  }
};